module.exports = __webpack_public_path__ + "static/animated-illustration-3-c64ab2735b4c547e276e3721b7678dae.gif";